import React, { Component } from 'react';
import './CaseSingleAbout.css';
import CaseDetails from './CaseDetails/index';
import XBRLDetails from './XBRLDetails/index';
//import { DataAutomation } from '../../List/Table/DataAutomationDetails/index';
import { showETA, setRequestBodyDataAutomation } from './Helper';
import { Card, Nav, Navbar, NavLink, NavItem, Collapse } from 'reactstrap';
import * as constants from '../../constants';
import WithdrawnReasonPopover from './Popover/index';
class AboutView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            caseCollapsed: false,
            xbrlCollapsed: false,
            dataAutomationCollapsed: false,
            //dataAutomationData: {}
        }
    }
    toggleCaseDetails = () => {
        this.setState((prevState) => ({
            caseCollapsed: !prevState.caseCollapsed,
            xbrlCollapsed: false,
            //dataAutomationCollapsed: false
        }))
    }
    toggleXbrlDetails = () => {
        this.setState((prevState) => ({
            xbrlCollapsed: !prevState.xbrlCollapsed,
            caseCollapsed: false,
           // dataAutomationCollapsed: false
        }))
    }
    /* toggleDataAutomationDetails = () => {
        this.setState((prevState) => ({
            xbrlCollapsed: false,
            caseCollapsed: false,
            dataAutomationCollapsed: !prevState.dataAutomationCollapsed
        }))
    } */
   
    render() {
        return (
            <Card className="mb-4">
                <div>
                    <Navbar color="light" light expand="md">
                        <Nav>
                            <NavItem>
                              <NavLink href="#" onClick={this.toggleCaseDetails}>Case Details - {this.props.metadata.counterpartyName} ({this.props.metadata.status})</NavLink>
                            </NavItem>
                            {/* <NavItem>
                                <NavLink href="#" onClick={this.toggleXbrlDetails}> XBRL Details </NavLink>
                            </NavItem> */}
                            {/* <NavItem>
                                <NavLink href="#" onClick={this.toggleDataAutomationDetails}>Data Automation </NavLink>
                            </NavItem> */}
                        </Nav>

                    </Navbar>
                    <Collapse isOpen={this.state.caseCollapsed} navbar>
                        <CaseDetails {...this.props} />
                    </Collapse>
                    <Collapse isOpen={this.state.xbrlCollapsed} navbar>
                        <XBRLDetails uploadxbrlFileCallback={this.props.uploadXbrlCallback} {...this.props} downloadXbrlCallback={this.props.downloadXbrl} rerunProcessingCallback={this.props.rerunProcessing} />
                    </Collapse>
                    {/* <Collapse isOpen={this.state.dataAutomationCollapsed}>
                        <DataAutomation handleRunCallback={this.handleRunAutomation} dataAutomationData={this.state.dataAutomationData} handleCheckboxchange={this.handleCheckboxchange} />
                    </Collapse> */}
                </div>
                {/* <table className="table table-bordered border-bottom-0 case-about-table">
                <thead className="header-blue">
                    <tr>
                        <th width="15%">Case ID</th>
                        <th width="15%">Case Name</th>
                        <th width="15%">Client Name</th>
                        <th width="15%">Created on</th>
                        <th width="10%">Due date</th>
                        <th width="15%">Status</th>
                        <th width="15%">Allocated to</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td title={props.metadata.caseId} className="text-truncate"> {props.metadata.caseId} </td>
                        <td title={props.metadata.counterpartyName} className="text-truncate"> {props.metadata.counterpartyName} </td>
                        <td title={props.metadata.corporateName} className="text-truncate"> {props.metadata.corporateName} </td>
                        <td> {showETA(props.metadata.createdAt)} </td>
                        <td> {showETA(props.metadata.dueDate)} </td>
                        <td> {props.metadata.status}{props.viewPublishedReport}
                            {(props.metadata.status === constants.WITHDRAWN) ?  < WithdrawnReasonPopover withdrawnReason = {props.metadata.withdrawalReason}/> : ''}
                        </td>
                        <td title={props.metadata.assignedTo} className="text-truncate"> {props.metadata.assignedTo} </td>
                    </tr>
                </tbody>
            </table> */}
            </Card>
        )
    }
}

export default AboutView
